import { BaseApiService } from '@/shared/api/BaseApiService';

export interface DayBreak {
  startTime: string;
  endTime: string;
  label?: string;
}

export interface DaySchedule {
  dayOfWeek: number;
  isOpen: boolean;
  startTime: string;
  endTime: string;
  breaks: DayBreak[];
}

export interface UpdateWorkingHoursInput {
  schedules: DaySchedule[];
}

export class SettingsService extends BaseApiService {
  protected readonly resourcePath = 'settings';

  async getFeatureFlag(key: string): Promise<boolean> {
    return this.get(`/feature-flags/${key}`);
  }

  async setFeatureFlag(
    key: string,
    enabled: boolean,
  ): Promise<{ flagKey: string; enabled: boolean }> {
    return this.patch(`/feature-flags/${key}`, { enabled });
  }

  async getWorkingHours(): Promise<DaySchedule[]> {
    return this.get('/working-hours');
  }

  async updateWorkingHours(input: UpdateWorkingHoursInput): Promise<DaySchedule[]> {
    return this.put('/working-hours', input);
  }
}
